<script lang="ts" setup>
import type { ShareButtonsLink } from '~/components/share-buttons/link/ShareButtonsLink.vue'
import './ShareButtons.scss'

export interface ShareButtonsProps {
    title: string
    thumbnail: string
}

const route = useRoute()
const config = useRuntimeConfig()
const { $t } = useNuxtApp()
const shareUrl = computed<string>(
    () => `${config.public.publicPath}${route.fullPath}`
)
const props = defineProps<ShareButtonsProps>()

const buttons = reactive<ShareButtonsLink[]>([
    {
        icon: 'facebook-outline',
        label: $t('Zdieľať na Facebooku'),
        url: `http://www.facebook.com/sharer.php?u=${shareUrl.value}`,
    },
    {
        icon: 'twitter-outline',
        label: $t('Zdieľať na X'),
        url: `https://twitter.com/share?url=${shareUrl.value}&text=${props.title}`,
    },
    {
        icon: 'pinterest',
        label: $t('Zdieľať na Pinterest'),
        url: `http://pinterest.com/pin/create/button/?url=${shareUrl.value}&description=${props.title}&media=${props.thumbnail}`,
    },
])
</script>

<template>
  <aside data-cy="share_buttons">
    <span class="share_buttons-title">
      {{ $t('Zdieľať') }}
    </span>
    <ul class="d-flex flex-md-column gap-2">
      <li
        v-for="(button, index) in buttons"
        :key="`sbl-${index}`"
      >
        <ShareButtonsLink :data="button" />
      </li>
    </ul>
    <IconsWrapper>
      <IconsSymbolTwitterOutline />
      <IconsSymbolFacebookOutline />
      <IconsSymbolPinterest />
    </IconsWrapper>
  </aside>
</template>
